var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"color":'#2E75B5',"height":90,"width":90}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }